import { createAsyncThunk } from "@reduxjs/toolkit"
import { EmailLog } from "@/types"
import { httpGet } from "@/lib/http"

export const fetchEmailLogs = createAsyncThunk<EmailLog[], { startDate: string; endDate: string }, { rejectValue: string }>(
  "emailLogs/fetchAll",
  async ({ startDate, endDate }, { rejectWithValue, dispatch }) => {
    try {
      const url = `admin/email?startDate=${startDate}&endDate=${endDate}`
      const res = await httpGet({ url, dispatch })

      const raw = res?.data
      if (!raw) return []

      const allEmails = raw?.emailLogSummary?.allEmails
      if (!Array.isArray(allEmails)) return []

      return allEmails.map((e: any) => ({
        id: e.id || e._id,
        to: e.toEmail || e.to || e.recipient || e.email || '',
        subject: e.subject || '',
        emailType: e.emailType || '',
        status: e.status || e.deliveryStatus || 'SENT',
        sentAt: e.sentAt || e.createdAt || e.timestamp,
        errorMessage: e.errorMessage || null,
      })) as EmailLog[]
    } catch (error: any) {
      return rejectWithValue(error.message)
    }
  }
)
